// extracted by mini-css-extract-plugin
export var button = "SliderNavigation-module--button--kWdhi";
export var buttonNext = "SliderNavigation-module--buttonNext--nb2--";
export var buttonPrev = "SliderNavigation-module--buttonPrev--1Iazi";